<template>
  <div>
    <el-dialog
      title=""
      center
      :visible.sync="visible"
      width="460px"
      :before-close="handleClose"
      append-to-body
    >
      <template slot="title">
        <div>全部验收</div>
      </template>
      <el-form :model="form" ref="formRef" label-width="150px" size="mini">
        <el-form-item label="采购数量:"
          >{{ row ? row.purchase_num : "" }}{{ row ? row.unit_name : "" }}
        </el-form-item>
        <el-form-item label="已验数量:">
          {{ row ? row.accept_num : "" }}{{ row ? row.unit_name : "" }}
        </el-form-item>
        <el-form-item
          label="本次验收:"
          prop="num"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <el-input
            style="width: 200px"
            v-model="form.num"
            filterable
            placeholder="请输入"
          >
            <el-button slot="append" @click="unitClick">
              <i class="el-icon-edit" style="color: #409eff"></i>
              <span style="color: #409eff; margin-left: 4px">{{
                form.cov_times ? form.cov_unit : form.unit
              }}</span>
              <span v-if="form.cov_times != 0"
                >（{{ form.cov_times }}{{ form.unit }}）</span
              >
            </el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label="仓库:"
          prop="stash_id"
          :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        >
          <el-select
            style="width: 200px"
            v-model="form.stash_id"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in stashArr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button
          type="primary"
          :loading="btnLoading"
          :disabled="btnLoading"
          @click="confirm"
          >确定全部验收</el-button
        >
      </template>
      <el-dialog
        title=""
        center
        :visible.sync="unitVisible"
        width="400px"
        :before-close="handleunitClose"
        append-to-body
      >
        <template slot="title">
          <div>选择单位</div>
        </template>
        <el-form
          :model="unitForm"
          ref="unitformRef"
          label-width="60px"
          label-position="right"
          size="mini"
        >
          <el-form-item
            label="单位:"
            prop="cov_unit"
            :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
          >
            <el-select
              size="mini"
              style="width: 100%"
              v-model="unitForm.cov_unit"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in unitArr"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="row && unitForm.cov_unit != row.unit_name"
            label="=:"
            prop="cov_times"
            :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
          >
            <el-input
              size="mini"
              v-model="unitForm.cov_times"
              placeholder="请输入"
            >
              <span slot="suffix">{{ row ? row.unit_name : "" }}</span>
            </el-input>
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button type="primary" @click="unitconfirm">确定</el-button>
        </template>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["stashArr", "unitArr"],
  data() {
    return {
      visible: false,
      form: {
        stash_id: "",
        num: "",
        unit: "",
        cov_times: "",
        cov_unit: "",
      },
      row: null,
      unitForm: {
        cov_times: "",
        cov_unit: "",
      },
      unitVisible: false,
      btnLoading: false,
    };
  },
  methods: {
    getDetails(row) {
      this.row = row;
      this.form.unit = row.unit_name;
      this.form.stash_id = row.stash_id ? row.stash_id : "";
      this.form.num = row.purchase_num - row.accept_num;
    },
    toggle(show) {
      this.visible = show;
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate();
      });
      !show && this.reset();
    },
    reset(done) {
      this.form.stash_id = "";
      this.form.num = "";
      this.form.unit = "";
      this.form.cov_times = "";
      this.form.cov_unit = "";
      this.row = null;
      done && done();
    },
    handleClose() {
      this.toggle(false);
    },
    handleunitClose() {
      this.unitVisible = false;
      this.unitForm.cov_times = "";
      this.unitForm.cov_unit = "";
      this.$refs.unitformRef.clearValidate();
    },
    getUnitName(id) {
      let obj = this.unitArr.find((item) => item.id == id);
      return obj ? obj.name : "无";
    },
    unitClick() {
      this.unitVisible = true;
      this.unitForm.cov_unit = this.form.unit;
      this.$nextTick(() => {
        this.$refs.unitformRef.clearValidate();
      });
    },
    unitconfirm() {
      this.$refs.unitformRef.validate((valid) => {
        if (valid) {
          this.form.cov_times = this.unitForm.cov_times;
          this.form.cov_unit = this.unitForm.cov_unit;
          this.handleunitClose();
        }
      });
    },
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let _params = {
            ids: this.row.order_ids.join(","),
            cov_times: this.form.cov_times,
            cov_unit: this.form.cov_unit,
            stash_id: this.form.stash_id,
            num: this.form.num,
            type: 2,
          };
          this.btnLoading = true;
          this.$http
            .post("/admin/accept/operation", _params)
            .then((res) => {
              if (res.code == 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>